<div class="fonte-dados-frm">
  <div class="versoes" *ngIf="entidade && entidade.extrator">
    <span *ngIf="entidade.extrator?.conversorVersao" class="label label-info"  [pTooltip]="entidade.extrator?.conversorVersaoDataImplantacao | date: 'dd/MM/yyyy HH:mm:ss'">
      Conversor: {{ entidade.extrator?.conversorVersao }}
    </span>
    <span *ngIf="entidade.extrator?.extratorVersao" class="label label-info"  [pTooltip]="entidade.extrator?.extratorVersaoDataImplantacao | date: 'dd/MM/yyyy HH:mm:ss'">
      Extrator: {{ entidade.extrator?.extratorVersao }}
    </span>
    <span *ngIf="entidade.extrator?.prismaVersao" class="label label-info"  [pTooltip]="entidade.extrator?.prismaVersaoDataImplantacao | date: 'dd/MM/yyyy HH:mm:ss'">
      Prisma: {{ entidade.extrator?.prismaVersao }}
    </span>
    <span *ngIf="entidade.extrator?.irisVersao" class="label label-info"  [pTooltip]="entidade.extrator?.irisVersaoDataImplantacao | date: 'dd/MM/yyyy HH:mm:ss'">
      Iris: {{ entidade.extrator?.irisVersao }}
    </span>
  </div>

  <p-tabView [(activeIndex)]="tabViewIndex" (onChange)="onChangeTabView()"  *ngIf="entidade">
    <p-tabPanel header="Dados">
      <div class="p-fluid">
        <div class="p-grid">
          <div class="p-col-12 p-lg-2">
            <label for="id">Id:</label>
          </div>
          <div class="p-col-12 p-lg-10">
            <input pInputText type="text" name="id" readonly [ngModel]="entidade.id" />
          </div>
        </div>

        <div class="p-grid">
          <div class="p-col-12 p-lg-2">
            <label for="tipo">Tipo:</label>
          </div>
          <div class="p-col-12 p-lg-10">
            <p-selectButton [options]="tipoItens" [disabled]="entidade.id !== undefined" [(ngModel)]="entidade.tipo">
            </p-selectButton>
          </div>
        </div>

        <div *ngIf="isExtrator(entidade.tipo)">

          <div class="p-grid">
            <div class="p-col-12 p-lg-2">
              <label for="nome">Orgão Justiça:</label>
            </div>
            <div class="p-col-12 p-lg-10">
              <p-dropdown placeholder="Selecione..." [options]="orgaoJusticaItens" [showClear]="true"
                          [disabled]="entidade.id !== undefined" (onChange)="onChangeOrgaoJustica()" optionLabel="nome" dataKey="id"
                          filter="true" [(ngModel)]="entidade?.extrator.orgaoJustica">
              </p-dropdown>
            </div>
          </div>

          <div class="p-grid">
            <div class="p-col-12 p-lg-2">
              <label for="sistemaProcessual">Sistema processual:</label>
            </div>
            <div class="p-col-12 p-lg-10">
              <p-dropdown placeholder="Selecione o sistema processual..." [options]="sistemaProcessualItens"
                          [disabled]="entidade.id !== undefined || entidade.extrator?.orgaoJustica === undefined"
                          (onChange)="onChangeSistemaProcessual()" filter="true" [(ngModel)]="entidade.extrator.sistemaProcessual">
                <ng-template let-item pTemplate="item">
                  <span>{{item.label}}</span>
                </ng-template>
              </p-dropdown>
            </div>
          </div>

          <div class="p-grid">
            <div class="p-col-12 p-lg-2">
              <label for="tipoSistemaProcessual">Tipo Sistema Processual:</label>
            </div>
            <div class="p-col-12 p-lg-10">
              <p-dropdown placeholder="Selecione o tipo de sistema processual..."
                          [disabled]="entidade.id !== undefined || entidade.extrator?.sistemaProcessual === undefined"
                          [options]="tipoSistemaProcessualItens" filter="true" [(ngModel)]="entidade.extrator.tipoSistemaProcessual">
                <ng-template let-item pTemplate="item">
                  <span>{{item.label}}</span>
                </ng-template>
              </p-dropdown>
            </div>
          </div>

          <div class="p-grid">
            <div class="p-col-12 p-lg-2">
              <label for="instancia">Instância:</label>
            </div>
            <div class="p-col-12 p-lg-10">
              <p-dropdown placeholder="Selecione a instância..." (onChange)="onChangeInstancia()"
                          [disabled]="entidade.extrator.tipoSistemaProcessual === undefined || (entidade.id !== undefined && isSistemaPJe())"
                          [options]="instanciaItens" filter="true" [(ngModel)]="entidade.extrator.instancia">
                <ng-template let-item pTemplate="item">
                  <span>{{item.label}}</span>
                </ng-template>
              </p-dropdown>
            </div>
          </div>

          <div class="p-grid">
            <div class="p-col-12 p-lg-2">
              <label for="nome">Nome:</label>
            </div>
            <div class="p-col-12 p-lg-10">
              <input [disabled]="entidade.id !== undefined || entidade.extrator.instancia === undefined" pInputText
                     type="text" name="nome" [ngModel]="entidade.nome" (ngModelChange)="entidade.nome = $event.toUpperCase()"
                     (input)="onInputNome()" [readonly]="isSistemaPJe()" />
            </div>
          </div>

          <div class="p-grid">
            <div class="p-col-12 p-lg-2">
              <label for="usuario">Usuário:</label>
            </div>
            <div class="p-col-12 p-lg-10">
              <input pInputText type="text" name="usuario" [(ngModel)]="entidade.usuario" readonly="true"
                     [disabled]="entidade.id !== undefined" />
            </div>
          </div>

          <div class="p-grid">
            <div class="p-col-12 p-lg-2">
              <label for="senha">Senha:</label>
            </div>
            <div class="p-col-12 p-lg-10">
              <div class="p-inputgroup">
                <input pInputText type="text" name="fonte-senha" autocomplete="off" [(ngModel)]="entidade.novaSenha" />
                <button type="button" pButton (click)="gerarSenha()" icon="pi pi-refresh" title="Gerar senha automaticamente"></button>
              </div>
            </div>
          </div>

          <div class="p-grid">
            <div class="p-col-12 p-lg-2">
              <label for="timezone">Timezone:</label>
            </div>
            <div class="p-col-12 p-lg-10">
              <p-checkbox
                [(ngModel)]="selecionarTimezoneParaTodosMicroServicos"
                binary="true"
              >
              </p-checkbox>
              <label for="timezone" style="margin-left: 8px;">Selecionar o mesmo timezone para todos micro-serviços</label>

              <div *ngIf="selecionarTimezoneParaTodosMicroServicos" class="p-grid" style="margin-top: 8px;">
                <div class="p-col-12">
                  <label for="todosMicroServicos">Conversor / Extrator / Prisma / Iris:</label>
                  <p-dropdown
                    placeholder="Selecione a timezone..."
                    (onChange)="onChangeTimezone()"
                    [options]="timezoneLista"
                    filter="true"
                    [(ngModel)]="timezoneGlobal">
                    <ng-template let-item pTemplate="item">
                      <span>{{ item }}</span>
                    </ng-template>
                  </p-dropdown>
                </div>
              </div>

              <div *ngIf="!selecionarTimezoneParaTodosMicroServicos" class="p-grid" style="margin-top: 8px;">
                <div class="p-col-12 p-md-6 p-lg-3">
                  <label for="conversor">Conversor:</label>
                  <p-dropdown
                    placeholder="Selecione a timezone..."
                    [options]="timezoneLista"
                    filter="true"
                    [(ngModel)]="entidade.extrator.conversorTimezone">
                    <ng-template let-item pTemplate="item">
                      <span>{{ item }}</span>
                    </ng-template>
                  </p-dropdown>
                </div>

                <div class="p-col-12 p-md-6 p-lg-3">
                  <label for="extrator">Extrator:</label>
                  <p-dropdown
                    placeholder="Selecione a timezone..."
                    [options]="timezoneLista"
                    filter="true"
                    [(ngModel)]="entidade.extrator.extratorTimezone">
                    <ng-template let-item pTemplate="item">
                      <span>{{ item }}</span>
                    </ng-template>
                  </p-dropdown>
                </div>

                <div class="p-col-12 p-md-6 p-lg-3">
                  <label for="prisma">Prisma:</label>
                  <p-dropdown
                    placeholder="Selecione a timezone..."
                    [options]="timezoneLista"
                    filter="true"
                    [(ngModel)]="entidade.extrator.prismaTimezone">
                    <ng-template let-item pTemplate="item">
                      <span>{{ item }}</span>
                    </ng-template>
                  </p-dropdown>
                </div>

                <div class="p-col-12 p-md-6 p-lg-3">
                  <label for="iris">Iris:</label>
                  <p-dropdown
                    placeholder="Selecione a timezone..."
                    [options]="timezoneLista"
                    filter="true"
                    [(ngModel)]="entidade.extrator.irisTimezone">
                    <ng-template let-item pTemplate="item">
                      <span>{{ item }}</span>
                    </ng-template>
                  </p-dropdown>
                </div>
              </div>
            </div>
          </div>


          <div class="p-grid">
            <div class="p-col-12 p-lg-2">
              <label for="urlLeitura">URL:</label>
            </div>
            <div class="p-col-12 p-lg-10">
              <input pInputText type="text" name="url" [(ngModel)]="entidade.url" />
            </div>
          </div>

          <div class="p-grid" *ngIf="entidade.id !== undefined">
            <div class="p-col-12 p-lg-2">
              <label for="nome">Recebendo Mensagens?:</label>
            </div>
            <div class="p-col-12 p-lg-10">
              <p-inputSwitch [(ngModel)]="entidade.extrator.recebendoMensagens" class="switch-p"></p-inputSwitch>
            </div>
          </div>

          <div class="p-grid">
            <div class="p-col-12 p-lg-2">
              <label for="observacoes">Observações:</label>
            </div>
            <div class="p-col-12 p-lg-10">
              <textarea pInputTextarea [(ngModel)]="entidade.observacoes" placeholder="Informações adicionais a salvar"
                        [rows]="5" [cols]="30" autoResize="autoResize">
              </textarea>
            </div>
          </div>
        </div>
      </div>
    </p-tabPanel>

    <p-tabPanel header="Estatísticas" [disabled]="entidade.id === undefined || isIntegracao(entidade.tipo)">

      <div *ngIf="fonteDadosEstatisticasLocal">

        <div style="margin: .5em 0">
          Última atualização em: {{fonteDadosEstatisticasLocal.data | date: 'dd/MM/yyyy HH:mm:ss'}}
        </div>

        <div class="form-action p-grid p-fluid">
          <div class="p-col-12">
            <button pButton (click)="coletarEstatisticasLocais()" label="Coletar estatísticas"></button>
          </div>
        </div>

        <div class="p-fluid">
          <div class="p-field">
            <app-fonte-dados-visualizador-processo-processamento #dlgVlzProcessoProcessamento [fonteDados]="entidade">
            </app-fonte-dados-visualizador-processo-processamento>
          </div>
          <div class="p-field">
            <app-fonte-dados-visualizador-pessoa-processamento #dlgVlzPessoaProcessamento [fonteDados]="entidade">
            </app-fonte-dados-visualizador-pessoa-processamento>
          </div>
          <div class="p-field">
            <app-fonte-dados-visualizador-processo-documento-processamento #dlgVlzProcessoDocumentoProcessamento [fonteDados]="entidade" [mostrarEstatisticaDocAtualizada]="mostrarEstatisticaDocAtualizada">
            </app-fonte-dados-visualizador-processo-documento-processamento>
          </div>
        </div>
        <fieldset style="margin-top: 1em">
          <legend>Processos: <a href="https://git.cnj.jus.br/ia/docs/-/wikis/Codex/Erros-nas-filas-de-fonte-dados#se%C3%A7%C3%A3o-processos" title="Clique aqui para acessar a wiki e solucionar as falhas de processamento"><i class="pi pi-info-circle"></i></a></legend>
          <div class="p-table p-component p-datatable-responsive">
            <div class="p-datatable-caption">
              Total: <a [routerLink]="" (click)="dlgVlzProcessoProcessamento.mostrar('comunicacao', undefined)">{{fonteDadosEstatisticasLocal.processos.total | number }}</a>
            </div>
            <div class="p-datatable-wrapper">
              <table class="table-bordered table-hover"
                     responsive="true"
                     sortMode="multiple"
                     responsiveLayout="scroll"
                     styleClass="p-datatable-striped">
                <thead>
                <tr>
                  <th>Item</th>
                  <th>Processados</th>
                  <th>Pendentes</th>
                  <th>Falhas <span class="pi pi-info-circle cl-blue"  [pTooltip]='tooltipInfoFalha'></span></th>
                  <th>Quarentena <span class="pi pi-info-circle cl-blue"  [pTooltip]='tooltipInfoQuarentena'></span></th>
                  <th>Suspensos <span class="pi pi-info-circle cl-blue" [pTooltip]='tooltipInfoSuspenso'></span> </th>
                  <th>Inaptos</th>
                  <th>Excluídos</th>
                </tr>
                </thead>
                <tbody class="p-datatable-tbody">
                <tr>
                  <td>Comunicados</td>
                  <td><a [routerLink]="" (click)="dlgVlzProcessoProcessamento.mostrar('comunicacao', 'PROCESSADO')">{{fonteDadosEstatisticasLocal.processos.comunicados | number }}</a></td>
                  <td><a [routerLink]="" (click)="dlgVlzProcessoProcessamento.mostrar('comunicacao', 'PENDENTE')">{{fonteDadosEstatisticasLocal.processos.pendentesComunicacao | number }}</a></td>
                  <td><a [routerLink]="" (click)="dlgVlzProcessoProcessamento.mostrar('comunicacao', 'FALHA_PROCESSAMENTO')">{{fonteDadosEstatisticasLocal.processos.comFalhasProcessamentoComunicacao | number }}</a></td>
                  <td><a [routerLink]="" (click)="dlgVlzProcessoProcessamento.mostrar('comunicacao', 'QUARENTENA')">{{fonteDadosEstatisticasLocal.processos.emQuarentenaComunicacao | number }}</a></td>
                  <td><a [routerLink]="" (click)="dlgVlzProcessoProcessamento.mostrar('comunicacao', 'SUSPENSO')">{{fonteDadosEstatisticasLocal.processos.suspensosComunicacao | number }}</a></td>
                  <td><a [routerLink]="" (click)="dlgVlzProcessoProcessamento.mostrar('comunicacao', 'INAPTO')">{{fonteDadosEstatisticasLocal.processos.inaptos | number }}</a></td>
                  <td><a [routerLink]="" (click)="dlgVlzProcessoProcessamento.mostrar('comunicacao', 'EXCLUIDO')">{{fonteDadosEstatisticasLocal.processos.excluidos | number }}</a></td>
                </tr>
                <tr>
                  <td>Sincronizados</td>
                  <td><a [routerLink]="" (click)="dlgVlzProcessoProcessamento.mostrar('sincronizado', true)">{{fonteDadosEstatisticasLocal.processos.sincronizados | number }}</a></td>
                  <td><a [routerLink]="" (click)="dlgVlzProcessoProcessamento.mostrar('sincronizado', false)">{{fonteDadosEstatisticasLocal.processos.pendentesSincronizacao | number}}</a></td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                </tr>
                <tr>
                  <td>Alteração de documentos</td>
                  <td>-</td>
                  <td><a [routerLink]="" (click)="dlgVlzProcessoProcessamento.mostrar('ultimaAlteracaoDocumentos', 'PENDENTE')">{{fonteDadosEstatisticasLocal.processos.pendentesAlteracaoDocumentos | number }}</a></td>
                  <td><a [routerLink]="" (click)="dlgVlzProcessoProcessamento.mostrar('ultimaAlteracaoDocumentos', 'FALHA_PROCESSAMENTO')">{{fonteDadosEstatisticasLocal.processos.comFalhasProcessamentoAlteracaoDocumentos | number }}</a></td>
                  <td><a [routerLink]="" (click)="dlgVlzProcessoProcessamento.mostrar('ultimaAlteracaoDocumentos', 'QUARENTENA')">{{fonteDadosEstatisticasLocal.processos.emQuarentenaAlteracaoDocumentos | number }}</a></td>
                  <td><a [routerLink]="" (click)="dlgVlzProcessoProcessamento.mostrar('ultimaAlteracaoDocumentos', 'SUSPENSO')">{{fonteDadosEstatisticasLocal.processos.suspensosAlteracaoDocumentos | number }}</a></td>
                  <td>-</td>
                  <td>-</td>
                </tr>
                <tr>
                  <td>Alteração de metadados</td>
                  <td>-</td>
                  <td><a [routerLink]="" (click)="dlgVlzProcessoProcessamento.mostrar('ultimaAlteracaoMetadados', 'PENDENTE')">{{fonteDadosEstatisticasLocal.processos.pendentesAlteracaoMetadados | number }}</a></td>
                  <td><a [routerLink]="" (click)="dlgVlzProcessoProcessamento.mostrar('ultimaAlteracaoMetadados', 'FALHA_PROCESSAMENTO')">{{fonteDadosEstatisticasLocal.processos.comFalhasProcessamentoAlteracaoMetadados | number }}</a></td>
                  <td><a [routerLink]="" (click)="dlgVlzProcessoProcessamento.mostrar('ultimaAlteracaoMetadados', 'QUARENTENA')">{{fonteDadosEstatisticasLocal.processos.emQuarentenaAlteracaoMetadados | number }}</a></td>
                  <td><a [routerLink]="" (click)="dlgVlzProcessoProcessamento.mostrar('ultimaAlteracaoMetadados', 'SUSPENSO')">{{fonteDadosEstatisticasLocal.processos.suspensosAlteracaoMetadados | number }}</a></td>
                  <td>-</td>
                  <td>-</td>
                </tr>
                <tr>
                  <td>Alteração de movimentos</td>
                  <td>-</td>
                  <td><a [routerLink]="" (click)="dlgVlzProcessoProcessamento.mostrar('ultimaAlteracaoMovimentos', 'PENDENTE')">{{fonteDadosEstatisticasLocal.processos.pendentesAlteracaoMovimentos | number }}</a></td>
                  <td><a [routerLink]="" (click)="dlgVlzProcessoProcessamento.mostrar('ultimaAlteracaoMovimentos', 'FALHA_PROCESSAMENTO')">{{fonteDadosEstatisticasLocal.processos.comFalhasProcessamentoAlteracaoMovimentos | number }}</a></td>
                  <td><a [routerLink]="" (click)="dlgVlzProcessoProcessamento.mostrar('ultimaAlteracaoMovimentos', 'QUARENTENA')">{{fonteDadosEstatisticasLocal.processos.emQuarentenaAlteracaoMovimentos | number }}</a></td>
                  <td><a [routerLink]="" (click)="dlgVlzProcessoProcessamento.mostrar('ultimaAlteracaoMovimentos', 'SUSPENSO')">{{fonteDadosEstatisticasLocal.processos.suspensosAlteracaoMovimentos | number }}</a></td>
                  <td>-</td>
                  <td>-</td>
                </tr>
                <tr>
                  <td>Alteração de partes</td>
                  <td>-</td>
                  <td><a [routerLink]="" (click)="dlgVlzProcessoProcessamento.mostrar('ultimaAlteracaoPartes', 'PENDENTE')">{{fonteDadosEstatisticasLocal.processos.pendentesAlteracaoPartes | number }}</a></td>
                  <td><a [routerLink]="" (click)="dlgVlzProcessoProcessamento.mostrar('ultimaAlteracaoPartes', 'FALHA_PROCESSAMENTO')">{{fonteDadosEstatisticasLocal.processos.comFalhasProcessamentoAlteracaoPartes | number }}</a></td>
                  <td><a [routerLink]="" (click)="dlgVlzProcessoProcessamento.mostrar('ultimaAlteracaoPartes', 'QUARENTENA')">{{fonteDadosEstatisticasLocal.processos.emQuarentenaAlteracaoPartes | number }}</a></td>
                  <td><a [routerLink]="" (click)="dlgVlzProcessoProcessamento.mostrar('ultimaAlteracaoPartes', 'SUSPENSO')">{{fonteDadosEstatisticasLocal.processos.suspensosAlteracaoPartes | number }}</a></td>
                  <td>-</td>
                  <td>-</td>
                </tr>
               </tbody>
              </table>
            </div>
          </div>
        </fieldset>

        <fieldset style="margin-top: 1em">
          <legend>Documentos: <a href="https://git.cnj.jus.br/ia/docs/-/wikis/Codex/Erros-nas-filas-de-fonte-dados#se%C3%A7%C3%A3o-documentos" alt="Clique aqui para acessar a wiki e solucionar as falhas de processamento"><i class="pi pi-info-circle"></i></a></legend>
          <div class="p-table p-component p-datatable-responsive">
            <div class="p-datatable-caption">
              Total: {{fonteDadosEstatisticasLocal.processosDocumentos.total | number }}
            </div>
            <div class="p-datatable-wrapper">
              <table class="table-bordered table-hover"
                     responsive="true"
                     sortMode="multiple"
                     responsiveLayout="scroll"
                     styleClass="p-datatable-striped">
                <thead class="p-datatable-thead">
                <tr>
                  <th>Item</th>
                  <th>Processados</th>
                  <th>Pendentes</th>
                  <th>Falhas <span class="pi pi-info-circle cl-blue"  [pTooltip]='tooltipInfoFalha'></span></th>
                  <th>Quarentena <span class="pi pi-info-circle cl-blue"  [pTooltip]='tooltipInfoQuarentena'></span></th>
                  <th>Suspensos <span class="pi pi-info-circle cl-blue" [pTooltip]='tooltipInfoSuspenso'></span> </th>
                  <th>Excluídos</th>
                </tr>
                </thead>
                <tbody class="p-datatable-tbody">
                <tr>
                  <td>Processados</td>
                  <td><a [routerLink]="" (click)="dlgVlzProcessoDocumentoProcessamento.mostrar('processamento', 'PROCESSADO')">{{fonteDadosEstatisticasLocal.processosDocumentos.processados | number }}</a></td>
                  <td><a [routerLink]="" (click)="dlgVlzProcessoDocumentoProcessamento.mostrar('processamento', 'PENDENTE')">{{fonteDadosEstatisticasLocal.processosDocumentos.pendentesProcessamento | number }}</a></td>
                  <td><a [routerLink]="" (click)="dlgVlzProcessoDocumentoProcessamento.mostrar('processamento', 'FALHA_PROCESSAMENTO')">{{fonteDadosEstatisticasLocal.processosDocumentos.comFalhasProcessamento | number }}</a></td>
                  <td><a [routerLink]="" (click)="dlgVlzProcessoDocumentoProcessamento.mostrar('processamento', 'QUARENTENA')">{{fonteDadosEstatisticasLocal.processosDocumentos.emQuarentenaProcessamento | number }}</a></td>
                  <td><a [routerLink]="" (click)="dlgVlzProcessoDocumentoProcessamento.mostrar('processamento', 'SUSPENSO')">{{fonteDadosEstatisticasLocal.processosDocumentos.suspensosProcessamento| number }}</a></td>
                  <td><a [routerLink]="" (click)="dlgVlzProcessoDocumentoProcessamento.mostrar('processamento', 'EXCLUIDO')">{{fonteDadosEstatisticasLocal.processosDocumentos.excluidos | number }}</a></td>
                </tr>
                <tr *ngIf="mostrarEstatisticaDocAtualizada">
                  <td>Comunicados</td>
                  <td><a [routerLink]="" (click)="dlgVlzProcessoDocumentoProcessamento.mostrar('comunicacao', 'PROCESSADO')">{{fonteDadosEstatisticasLocal.processosDocumentos.comunicados | number }}</a></td>
                  <td><a [routerLink]="" (click)="dlgVlzProcessoDocumentoProcessamento.mostrar('comunicacao', 'PENDENTE')">{{fonteDadosEstatisticasLocal.processosDocumentos.pendentesComunicacao | number}}</a></td>
                  <td><a [routerLink]="" (click)="dlgVlzProcessoDocumentoProcessamento.mostrar('comunicacao', 'FALHA_PROCESSAMENTO')">{{fonteDadosEstatisticasLocal.processosDocumentos.comFalhasComunicacao | number}}</a></td>
                  <td><a [routerLink]="" (click)="dlgVlzProcessoDocumentoProcessamento.mostrar('comunicacao', 'QUARENTENA')">{{fonteDadosEstatisticasLocal.processosDocumentos.emQuarentenaComunicacao | number}}</a></td>
                  <td><a [routerLink]="" (click)="dlgVlzProcessoDocumentoProcessamento.mostrar('comunicacao', 'SUSPENSO')">{{fonteDadosEstatisticasLocal.processosDocumentos.suspensosComunicacao | number}}</a></td>
                  <td>-</td>
                </tr>

                <tr *ngIf="!mostrarEstatisticaDocAtualizada">
                  <td>Comunicados</td>
                  <td><a [routerLink]="" (click)="dlgVlzProcessoDocumentoProcessamento.mostrar('sincronizado', true)">{{fonteDadosEstatisticasLocal.processosDocumentos.comunicados | number }}</a></td>
                  <td><a [routerLink]="" (click)="dlgVlzProcessoDocumentoProcessamento.mostrar('sincronizado', false)">{{fonteDadosEstatisticasLocal.processosDocumentos.pendentesComunicacao | number}}</a></td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </fieldset>

        <fieldset style="margin-top: 1em">
          <legend>Pessoas: <a href="https://git.cnj.jus.br/ia/docs/-/wikis/Codex/Erros-nas-filas-de-fonte-dados#se%C3%A7%C3%A3o-pessoas" alt="Clique aqui para acessar a wiki e solucionar as falhas de processamento"><i class="pi pi-info-circle"></i></a></legend>
          <div class="p-table p-component p-datatable-responsive">
            <div class="p-datatable-caption ">
              Total: <a [routerLink]="" (click)="dlgVlzPessoaProcessamento.mostrar('comunicacao', undefined)">{{fonteDadosEstatisticasLocal.pessoas.total | number }}</a>
            </div>
            <div class="p-datable-wrapper">
              <table class="table-bordered table-hover"
                     responsive="true"
                     sortMode="multiple"
                     responsiveLayout="scroll"
                     styleClass="p-datatable-striped">
                <thead class="p-datatable-thead">
                <tr>
                  <th class="text-left">Item</th>
                  <th class="text-left">Processados</th>
                  <th class="text-left">Pendentes</th>
                  <th>Falhas <span class="pi pi-info-circle cl-blue"  [pTooltip]='tooltipInfoFalha'></span></th>
                  <th>Quarentena <span class="pi pi-info-circle cl-blue"  [pTooltip]='tooltipInfoQuarentena'></span></th>
                  <th>Suspensas <span class="pi pi-info-circle cl-blue" [pTooltip]='tooltipInfoSuspenso'></span> </th>
                  <th class="text-left">Inaptos</th>
                  <th class="text-left">Excluídos</th>
                </tr>
                </thead>
                <tbody class="p-datatable-tbody">
                <tr>
                  <td>Comunicadas</td>
                  <td><a [routerLink]="" (click)="dlgVlzPessoaProcessamento.mostrar('comunicacao', 'PROCESSADO')">{{fonteDadosEstatisticasLocal.pessoas.comunicadas | number }}</a></td>
                  <td><a [routerLink]="" (click)="dlgVlzPessoaProcessamento.mostrar('comunicacao', 'PENDENTE')">{{fonteDadosEstatisticasLocal.pessoas.pendentesComunicacao | number }}</a></td>
                  <td><a [routerLink]="" (click)="dlgVlzPessoaProcessamento.mostrar('comunicacao', 'FALHA_PROCESSAMENTO')">{{fonteDadosEstatisticasLocal.pessoas.comFalhasProcessamentoComunicacao | number }}</a></td>
                  <td><a [routerLink]="" (click)="dlgVlzPessoaProcessamento.mostrar('comunicacao', 'QUARENTENA')">{{fonteDadosEstatisticasLocal.pessoas.emQuarentenaComunicacao | number }}</a></td>
                  <td><a [routerLink]="" (click)="dlgVlzPessoaProcessamento.mostrar('comunicacao', 'SUSPENSO')">{{fonteDadosEstatisticasLocal.pessoas.suspensasComunicacao | number }}</a></td>
                  <td><a [routerLink]="" (click)="dlgVlzPessoaProcessamento.mostrar('comunicacao', 'INAPTO')">{{fonteDadosEstatisticasLocal.pessoas.inaptas | number }}</a></td>
                  <td><a [routerLink]="" (click)="dlgVlzPessoaProcessamento.mostrar('comunicacao', 'EXCLUIDO')">{{fonteDadosEstatisticasLocal.pessoas.excluidas | number }}</a></td>
                </tr>
                <tr>
                  <td>Sincronizadas</td>
                  <td><a [routerLink]="" (click)="dlgVlzPessoaProcessamento.mostrar('sincronizada', true)">{{fonteDadosEstatisticasLocal.pessoas.sincronizadas | number }}</a></td>
                  <td><a [routerLink]="" (click)="dlgVlzPessoaProcessamento.mostrar('sincronizada', false)">{{fonteDadosEstatisticasLocal.pessoas.pendentesSincronizacao | number}}</a></td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                </tr>
                <tr>
                  <td>Alteração de documentos</td>
                  <td>-</td>
                  <td><a [routerLink]="" (click)="dlgVlzPessoaProcessamento.mostrar('ultimaAlteracaoDocumentos', 'PENDENTE')">{{fonteDadosEstatisticasLocal.pessoas.pendentesAlteracaoDocumentos | number }}</a></td>
                  <td><a [routerLink]="" (click)="dlgVlzPessoaProcessamento.mostrar('ultimaAlteracaoDocumentos', 'FALHA_PROCESSAMENTO')">{{fonteDadosEstatisticasLocal.pessoas.comFalhasProcessamentoAlteracaoDocumentos | number }}</a></td>
                  <td><a [routerLink]="" (click)="dlgVlzPessoaProcessamento.mostrar('ultimaAlteracaoDocumentos', 'QUARENTENA')">{{fonteDadosEstatisticasLocal.pessoas.emQuarentenaAlteracaoDocumentos | number }}</a></td>
                  <td><a [routerLink]="" (click)="dlgVlzPessoaProcessamento.mostrar('ultimaAlteracaoDocumentos', 'SUSPENSO')">{{fonteDadosEstatisticasLocal.pessoas.suspensasAlteracaoDocumentos | number }}</a></td>
                  <td>-</td>
                  <td>-</td>
                </tr>
                <tr>
                  <td>Alteração de metadados</td>
                  <td>-</td>
                  <td><a [routerLink]="" (click)="dlgVlzPessoaProcessamento.mostrar('ultimaAlteracaoMetadados', 'PENDENTE')">{{fonteDadosEstatisticasLocal.pessoas.pendentesAlteracaoMetadados | number }}</a></td>
                  <td><a [routerLink]="" (click)="dlgVlzPessoaProcessamento.mostrar('ultimaAlteracaoMetadados', 'FALHA_PROCESSAMENTO')">{{fonteDadosEstatisticasLocal.pessoas.comFalhasProcessamentoAlteracaoMetadados | number }}</a></td>
                  <td><a [routerLink]="" (click)="dlgVlzPessoaProcessamento.mostrar('ultimaAlteracaoMetadados', 'QUARENTENA')">{{fonteDadosEstatisticasLocal.pessoas.emQuarentenaAlteracaoMetadados | number }}</a></td>
                  <td><a [routerLink]="" (click)="dlgVlzPessoaProcessamento.mostrar('ultimaAlteracaoMetadados', 'SUSPENSO')">{{fonteDadosEstatisticasLocal.pessoas.suspensasAlteracaoMetadados | number }}</a></td>
                  <td>-</td>
                  <td>-</td>
                </tr>
                <tr>
                  <td>Alteração de endereços</td>
                  <td>-</td>
                  <td><a [routerLink]="" (click)="dlgVlzPessoaProcessamento.mostrar('ultimaAlteracaoEnderecos', 'PENDENTE')">{{fonteDadosEstatisticasLocal.pessoas.pendentesAlteracaoEnderecos | number }}</a></td>
                  <td><a [routerLink]="" (click)="dlgVlzPessoaProcessamento.mostrar('ultimaAlteracaoEnderecos', 'FALHA_PROCESSAMENTO')">{{fonteDadosEstatisticasLocal.pessoas.comFalhasProcessamentoAlteracaoEnderecos | number }}</a></td>
                  <td><a [routerLink]="" (click)="dlgVlzPessoaProcessamento.mostrar('ultimaAlteracaoEnderecos', 'QUARENTENA')">{{fonteDadosEstatisticasLocal.pessoas.emQuarentenaAlteracaoEnderecos | number }}</a></td>
                  <td><a [routerLink]="" (click)="dlgVlzPessoaProcessamento.mostrar('ultimaAlteracaoEnderecos', 'SUSPENSO')">{{fonteDadosEstatisticasLocal.pessoas.suspensasAlteracaoEnderecos | number }}</a></td>
                  <td>-</td>
                  <td>-</td>
                </tr>
                <tr>
                  <td>Alteração de outros nomes</td>
                  <td>-</td>
                  <td><a [routerLink]="" (click)="dlgVlzPessoaProcessamento.mostrar('ultimaAlteracaoOutrosNomes', 'PENDENTE')">{{fonteDadosEstatisticasLocal.pessoas.pendentesAlteracaoOutrosNomes | number }}</a></td>
                  <td><a [routerLink]="" (click)="dlgVlzPessoaProcessamento.mostrar('ultimaAlteracaoOutrosNomes', 'FALHA_PROCESSAMENTO')">{{fonteDadosEstatisticasLocal.pessoas.comFalhasProcessamentoAlteracaoOutrosNomes | number }}</a></td>
                  <td><a [routerLink]="" (click)="dlgVlzPessoaProcessamento.mostrar('ultimaAlteracaoOutrosNomes', 'QUARENTENA')">{{fonteDadosEstatisticasLocal.pessoas.emQuarentenaAlteracaoOutrosNomes | number }}</a></td>
                  <td><a [routerLink]="" (click)="dlgVlzPessoaProcessamento.mostrar('ultimaAlteracaoOutrosNomes', 'SUSPENSO')">{{fonteDadosEstatisticasLocal.pessoas.suspensasAlteracaoOutrosNomes | number }}</a></td>
                  <td>-</td>
                  <td>-</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </fieldset>
      </div>
    </p-tabPanel>

    <p-tabPanel header="De-para" *ngIf="entidade.id !== undefined" [disabled]="entidade.id === undefined || isIntegracao(entidade.tipo)">
      <app-fonte-dados-visualizador-de-para [fonteDados]="entidade" *ngIf="carregaDePara">
      </app-fonte-dados-visualizador-de-para>
    </p-tabPanel>

    <p-tabPanel header="Monitoramento" [disabled]="entidade.id === undefined || isIntegracao(entidade.tipo)">
      <div *ngIf="fonteDadosMonitoramento">
        <div style="margin: .5em 0">
          Última atualização em: {{fonteDadosMonitoramento.auditoriaDataInsercao | date: 'dd/MM/yyyy HH:mm:ss'}}
        </div>
      </div>
      <div class="form-action p-grid p-fluid">
        <div class="p-col-12">
          <button pButton (click)="coletarMonitoramento()" label="Monitorar"></button>
        </div>
      </div>
      <div class="p-fluid">
        <div class="p-grid">
          <div class="p-col-12">
            <app-aplicacao-monitoramento-visualizador [aplicacao]="monitoramento.conversor">
            </app-aplicacao-monitoramento-visualizador>
            <div *ngIf="fonteDadosMonitoramento">
              <div style="margin: .5em 0"  *ngIf="fonteDadosMonitoramento.conversorErro">
                {{fonteDadosMonitoramento.conversorErro}}
              </div>
            </div>
          </div>
        </div>
        <div class="p-grid">
          <div class="p-col-12">
            <app-aplicacao-monitoramento-visualizador [aplicacao]="monitoramento.extrator">
            </app-aplicacao-monitoramento-visualizador>
            <div *ngIf="fonteDadosMonitoramento">
              <div style="margin: .5em 0" *ngIf="fonteDadosMonitoramento.extratorErro">
                {{fonteDadosMonitoramento.extratorErro}}
              </div>
            </div>
          </div>
        </div>
        <div class="p-grid">
          <div class="p-col-12">
            <app-aplicacao-monitoramento-visualizador [aplicacao]="monitoramento.prisma">
            </app-aplicacao-monitoramento-visualizador>
            <div *ngIf="fonteDadosMonitoramento">
              <div style="margin: .5em 0" *ngIf="fonteDadosMonitoramento.prismaErro">
                {{fonteDadosMonitoramento.prismaErro}}
              </div>
            </div>
          </div>
        </div>
        <div class="p-grid">
          <div class="p-col-12">
            <app-aplicacao-monitoramento-visualizador [aplicacao]="monitoramento.iris">
            </app-aplicacao-monitoramento-visualizador>
            <div *ngIf="fonteDadosMonitoramento">
              <div style="margin: .5em 0" *ngIf="fonteDadosMonitoramento.irisErro">
                {{fonteDadosMonitoramento.irisErro}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </p-tabPanel>

    <p-tabPanel header="Infraestrutura" [disabled]="entidade.id === undefined">
      <ng-template pTemplate="content">
        <app-fonte-dados-infraestrutura [fonteDados]="entidade" [monitoramento]="monitoramento" [tabSelecionada]="tabViewIndex === 4" ></app-fonte-dados-infraestrutura>
      </ng-template>
    </p-tabPanel>

    <p-tabPanel header="Proxy" [disabled]="entidade.id === undefined">
      <app-fonte-dados-proxy [fonteDados]="entidade"></app-fonte-dados-proxy>
    </p-tabPanel>

    <p-tabPanel header="Banco de Dados" [disabled]="entidade.id === undefined || !mostrarAbaBancoDados">
      <app-fonte-dados-banco-de-dados *ngIf="tabViewIndex === 6" [fonteDados]="entidade"></app-fonte-dados-banco-de-dados>
    </p-tabPanel>


    <p-tabPanel header="Teste de Comunicação" [disabled]="entidade.id === undefined">
      <app-fonte-dados-comunicacao-lista *ngIf="tabViewIndex === 7" [fonteDados]="entidade"></app-fonte-dados-comunicacao-lista>
    </p-tabPanel>

    <p-tabPanel header="Auditoria" [disabled]="entidade.id === undefined">
      <div class="p-fluid">
        <div class="p-grid">
          <div class="p-col-12 p-lg-3  p-text-bold">Inserção - Data:</div>
          <div class="p-col-12 p-lg-9">{{entidade.auditoriaDataInsercao | date: 'dd/MM/yyyy HH:mm:ss'}}</div>
        </div>
        <div class="p-grid">
          <div class="p-col-12 p-lg-3  p-text-bold">Inserção - Usuário:</div>
          <div class="p-col-12 p-lg-9">{{entidade.auditoriaUsuarioInsercao?.nome}}</div>
        </div>
        <div class="p-grid">
          <div class="p-col-12 p-lg-3  p-text-bold">Última alteração - Data:</div>
          <div class="p-col-12 p-lg-9">{{entidade.auditoriaData | date: 'dd/MM/yyyy HH:mm:ss'}}</div>
        </div>
        <div class="p-grid">
          <div class="p-col-12 p-lg-3  p-text-bold">Última alteração - Usuário:</div>
          <div class="p-col-12 p-lg-9">{{entidade.auditoriaUsuario?.nome}}</div>
        </div>
      </div>
    </p-tabPanel>
  </p-tabView>

</div>
